import React from "react";
import { connect } from "react-redux";
import _ from "lodash";

import { Plus2ReportAdmin } from "./Plus2ReportAdmin";
import { Plus2ReportPolice } from "./Plus2ReportPoliceStation";
import { GunaReportPoliceAdmin } from "./GunaReportPs";
import { GunaReportAdmin } from "./GunaReportAdmin";
import { professionalAction } from "../../_actions";
import { CctnsGunaReportCom } from "./CctnsGunaRegisterComp";

class GunaReportCom extends React.Component {
  constructor(props) {
    super(props);
    this.myTableRef = React.createRef();
  }
  state = {};
  componentDidMount() {
    this.props.dispatch(professionalAction.getCity());
  }
  render() {
    const { user } = this.props;
    console.log("user", user);

    return (
      <>
        {user.role == "2" && <CctnsGunaReportCom />}
        {(user.role == "4" || user.role == "9" || user.role == "10") && (
          <GunaReportAdmin />
        )}
      </>
    );
  }
}

function mapStateToProps(state) {
  const { users, authentication, professionals } = state;
  const { user } = authentication;
  return {
    user,
    users,
    professionals,
  };
}

const connecteGunaReportCom = connect(mapStateToProps)(GunaReportCom);
export { connecteGunaReportCom as GunaReportCom };
